import localizationData from "./river.en.json";
import localized from "model/events/util";

const events = (context, setEvent) =>
  [
    {
      title: "event.riverCrossing.title",
      baseWeight: 50,
      isBuild: true,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.riverCrossing.spring.day.description",
            effect: { resources: { health: -5, food: -1 } },
          },
          night: {
            description: "event.riverCrossing.spring.night.description",
            effect: { resources: { health: -7 } },
          },
        },
        {
          season: "summer",
          day: {
            description: "event.riverCrossing.summer.day.description",
            effect: { resources: { water: +1, health: -3 } },
          },
          night: {
            description: "event.riverCrossing.summer.night.description",
            effect: { resources: { health: -5, food: -1 } },
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.riverCrossing.autumn.day.description",
            effect: { resources: { health: -4 } },
          },
          night: {
            description: "event.riverCrossing.autumn.night.description",
            effect: { resources: { health: -6 } },
          },
        },
        {
          season: "winter",
          day: {
            description: "event.riverCrossing.winter.day.description",
            effect: { resources: { health: -5 } },
          },
          night: {
            description: "event.riverCrossing.winter.night.description",
            effect: { resources: { health: -8 } },
          },
        },
      ],
      buttons: [
        {
          title: "event.riverCrossing.button.crossCarefully",
          message: "event.riverCrossing.button.message.crossCarefully",
          effect: { resources: { health: -2 } },
        },
        {
          title: "event.riverCrossing.button.buildRaft",
          message: "event.riverCrossing.button.message.buildRaft",
          effect: {
            resources: { food: +1 },
            traits: { resilience: +1 },
          },
        },
      ],
    },
    {
      title: "event.rapids.title",
      baseWeight: 40,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.rapids.spring.day.description",
            effect: { resources: { food: -10 } },
          },
          night: {
            description: "event.rapids.spring.night.description",
            effect: { resources: { food: -10 } },
          },
        },
        {
          season: "summer",
          day: {
            description: "event.rapids.summer.day.description",
            effect: { resources: { food: -10 } },
          },
          night: {
            description: "event.rapids.summer.night.description",
            effect: { resources: { food: -10 } },
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.rapids.autumn.day.description",
            effect: { resources: { food: -10 } },
          },
          night: {
            description: "event.rapids.autumn.night.description",
            effect: { resources: { food: -10 } },
          },
        },
        {
          season: "winter",
          day: {
            description: "event.rapids.winter.day.description",
            effect: { resources: { food: -10 } },
          },
          night: {
            description: "event.rapids.winter.night.description",
            effect: { resources: { food: -10 } },
          },
        },
      ],
      buttons: [
        {
          title: "event.rapids.button1.title",
          message: "event.rapids.button1.message",
          effect: { resources: { food: -10 } },
        },
      ],
    },
    {
      title: "event.mud.title",
      baseWeight: 30,
      isBuild: true,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.mud.description.spring.day",
            effect: { resources: { food: -10, water: -15 } },
          },
          night: {
            description: "event.mud.description.spring.night",
            effect: { resources: { food: -10, water: -15 } },
          },
        },
        {
          season: "summer",
          day: {
            description: "event.mud.description.summer.day",
            effect: { resources: { food: -10, water: -15 } },
          },
          night: {
            description: "event.mud.description.summer.night",
            effect: { resources: { food: -10, water: -15 } },
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.mud.description.autumn.day",
            effect: { resources: { food: -10, water: -15 } },
          },
          night: {
            description: "event.mud.description.autumn.night",
            effect: { resources: { food: -10, water: -15 } },
          },
        },
        {
          season: "winter",
          day: {
            description: "event.mud.description.winter.day",
            effect: { resources: { food: -10, water: -15 } },
          },
          night: {
            description: "event.mud.description.winter.night",
            effect: { resources: { food: -10, water: -15 } },
          },
        },
      ],
      buttons: [
        {
          title: "event.mud.button.title",
          message: "event.mud.button.message",
          effect: { resources: { food: -10, water: -15 } },
        },
      ],
    },
    {
      title: "event.river.title",
      outcome: "negative",
      state: "entering",
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.river.spring.day.description",
            effect: { resources: { health: -5 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.river.spring.night.description",
            effect: { resources: { morale: -1 } },
            weightAdjustment: 10,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.river.summer.day.description",
            effect: { resources: { water: -2 } },
            weightAdjustment: -5,
          },
          night: {
            description: "event.river.summer.night.description",
            effect: { traits: { stealth: +1 } },
            weightAdjustment: 5,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.river.autumn.day.description",
            effect: { resources: { food: -3 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.river.autumn.night.description",
            effect: {
              resources: { health: -7 },
              traits: { resilience: +1 },
            },
            weightAdjustment: 15,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.river.winter.day.description",
            effect: { resources: { ammo: -2 } },
            weightAdjustment: 10,
          },
          night: {
            description: "event.river.winter.night.description",
            effect: { resources: { coins: -5 } },
            weightAdjustment: 20,
          },
        },
      ],
      buttons: [
        {
          title: "event.river.button.cross",
          message: "event.river.button.message.cross",
          effect: {},
        },
        {
          title: "event.river.button.buildRaft",
          message: "event.river.button.message.buildRaft",
          effect: { traits: { resilience: +1 } },
        },
      ],
    },
    {
      title: "event.refreshed.title",
      outcome: "positive",
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.refreshed.spring.day.description",
            effect: { resources: { water: +15 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.refreshed.spring.night.description",
            effect: { resources: { water: +10 } },
            weightAdjustment: 5,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.refreshed.summer.day.description",
            effect: { resources: { water: +15 } },
            weightAdjustment: -5,
          },
          night: {
            description: "event.refreshed.summer.night.description",
            effect: { resources: { water: +10 } },
            weightAdjustment: 5,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.refreshed.autumn.day.description",
            effect: { resources: { water: +15 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.refreshed.autumn.night.description",
            effect: { resources: { water: +10 } },
            weightAdjustment: 10,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.refreshed.winter.day.description",
            effect: { resources: { water: +15 } },
            weightAdjustment: 10,
          },
          night: {
            description: "event.refreshed.winter.night.description",
            effect: { resources: { water: +10 } },
            weightAdjustment: 15,
          },
        },
      ],
      buttons: [
        {
          title: "event.refreshed.button.fill",
          message: "event.refreshed.button.message.fill",
          effect: { resources: { water: +15 } },
        },
      ],
    },
    {
      title: "event.swell.title",
      outcome: "negative",
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.swell.spring.day.description",
            effect: { resources: { ammo: -10 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.swell.spring.night.description",
            effect: { resources: { ammo: -10 } },
            weightAdjustment: 10,
          },
        },
      ],
      buttons: [
        {
          title: "event.swell.button.continue",
          message: "event.swell.button.message.continue",
          effect: { resources: { ammo: -10 } },
        },
      ],
    },
    {
      title: "event.hunt.title",
      outcome: "positive",
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.hunt.spring.day.description",
            effect: { resources: { food: +15 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.hunt.spring.night.description",
            effect: { resources: { food: +10 } },
            weightAdjustment: 5,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.hunt.summer.day.description",
            effect: { resources: { food: +15 } },
            weightAdjustment: -5,
          },
          night: {
            description: "event.hunt.summer.night.description",
            effect: { resources: { food: +10 } },
            weightAdjustment: 0,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.hunt.autumn.day.description",
            effect: { resources: { food: +20 } },
            weightAdjustment: -5,
          },
          night: {
            description: "event.hunt.autumn.night.description",
            effect: { resources: { food: +15 } },
            weightAdjustment: 0,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.hunt.winter.day.description",
            effect: { resources: { food: +10 } },
            weightAdjustment: 10,
          },
          night: {
            description: "event.hunt.winter.night.description",
            effect: { resources: { food: +5 } },
            weightAdjustment: 15,
          },
        },
      ],
      buttons: [
        {
          title: "event.hunt.button.collect",
          message: "event.hunt.button.message.collect",
          effect: {},
        },
      ],
    },
    {
      title: "event.bandits.title",
      isCombat: true,
      baseWeight: 30,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.bandits.spring.day.description",
            effect: {
              resources: { ammo: -10, health: -5, food: -20 },
            },
            weightAdjustment: 5,
          },
          night: {
            description: "event.bandits.spring.night.description",
            effect: {
              resources: { ammo: -15, health: -10, food: -25 },
            },
            weightAdjustment: 10,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.bandits.summer.day.description",
            effect: {
              resources: { ammo: -10, health: -5, food: -20 },
            },
            weightAdjustment: 0,
          },
          night: {
            description: "event.bandits.summer.night.description",
            effect: {
              resources: { ammo: -15, health: -10, food: -25 },
            },
            weightAdjustment: 5,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.bandits.autumn.day.description",
            effect: {
              resources: { ammo: -10, health: -5, food: -20 },
            },
            weightAdjustment: -5,
          },
          night: {
            description: "event.bandits.autumn.night.description",
            effect: {
              resources: { ammo: -15, health: -10, food: -25 },
            },
            weightAdjustment: 0,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.bandits.winter.day.description",
            effect: {
              resources: { ammo: -10, health: -5, food: -20 },
            },
            weightAdjustment: -10,
          },
          night: {
            description: "event.bandits.winter.night.description",
            effect: {
              resources: { ammo: -15, health: -10, food: -25 },
            },
            weightAdjustment: -5,
          },
        },
      ],
      buttons: [
        {
          title: "event.bandits.button.fight",
          combat: {
            enemies: ["bandit", "bandit", "bandit"],
            description: "event.bandits.button.fight.description",
            victory: "event.bandits.button.fight.victory",
            defeat: "event.bandits.button.fight.defeat",
          },
        },
        {
          title: "event.bandits.button.escape",
          message: "event.bandits.button.message.escape",
          effect: { resources: { ammo: -10, health: -5, food: -20 } },
        },
      ],
    },
    {
      title: "event.clearing.title",
      outcome: "positive",
      state: "isIn",
      baseWeight: 20,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.clearing.spring.day.description",
            effect: { resources: { health: +5 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.clearing.spring.night.description",
            effect: { resources: { health: +10 } },
            weightAdjustment: 10,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.clearing.summer.day.description",
            effect: { resources: { health: +5 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.clearing.summer.night.description",
            effect: { resources: { health: +10 } },
            weightAdjustment: 5,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.clearing.autumn.day.description",
            effect: { resources: { health: +10 } },
            weightAdjustment: -5,
          },
          night: {
            description: "event.clearing.autumn.night.description",
            effect: { resources: { health: +15 } },
            weightAdjustment: 0,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.clearing.winter.day.description",
            effect: { resources: { health: +5 } },
            weightAdjustment: -10,
          },
          night: {
            description: "event.clearing.winter.night.description",
            effect: { resources: { health: +10 } },
            weightAdjustment: -5,
          },
        },
      ],
      buttons: [
        {
          title: "event.clearing.button.relax",
          message: "event.clearing.button.message.relax",
          effect: {},
        },
      ],
    },
    {
      title: "event.ambush.title",
      baseWeight: 30,
      isCombat: true,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.ambush.spring.day.description",
            effect: {
              resources: {
                health: -10,
                ammo: -5,
              },
            },
            enemies: ["bandit", "bandit"],
            weightAdjustment: 5,
          },
          night: {
            description: "event.ambush.spring.night.description",
            effect: {
              resources: {
                health: -15,
                ammo: -10,
              },
              traits: {
                stealth: -1,
              },
            },
            enemies: ["outlaw", "outlaw", "outlaw"],
            weightAdjustment: 10,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.ambush.summer.day.description",
            effect: {
              resources: {
                health: -8,
                ammo: -8,
                food: -5,
              },
            },
            enemies: ["raider", "raider", "raider"],
            weightAdjustment: 0,
          },
          night: {
            description: "event.ambush.summer.night.description",
            effect: {
              resources: {
                health: -12,
                ammo: -12,
                food: -10,
              },
              traits: {
                resilience: +1,
              },
            },
            enemies: ["raider", "raider", "raider"],
            weightAdjustment: 5,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.ambush.autumn.day.description",
            effect: {
              resources: {
                health: -15,
                ammo: -10,
              },
              traits: {
                infamy: +1,
              },
            },
            enemies: ["tribesman", "tribesman"],
            weightAdjustment: -5,
          },
          night: {
            description: "event.ambush.autumn.night.description",
            effect: {
              resources: {
                health: -20,
                ammo: -15,
                food: -15,
              },
            },
            enemies: ["raider", "raider"],
            weightAdjustment: 0,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.ambush.winter.day.description",
            effect: {
              resources: {
                health: -10,
                ammo: -10,
                coins: -20,
              },
            },
            enemies: ["killer", "killer", "killer"],
            weightAdjustment: -10,
          },
          night: {
            description: "event.ambush.winter.night.description",
            effect: {
              resources: {
                health: -15,
                ammo: -15,
                coins: -30,
              },
              traits: {
                luck: -1,
              },
            },
            enemies: ["killer", "killer", "killer"],
            weightAdjustment: -5,
          },
        },
      ],
      buttons: [
        {
          title: "event.ambush.button.fight",
          combat: {
            description: "event.ambush.button.fight.description",
            victory: "event.ambush.button.fight.victory",
            defeat: "event.ambush.button.fight.defeat",
          },
        },
        {
          title: "event.ambush.button.flee",
          message: "event.ambush.button.message.flee",
        },
      ],
    },
    {
      title: "event.river.wildlife.title",
      baseWeight: 35,
      isCombat: true,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.river.wildlife.spring.day.description",
            effect: {
              resources: {
                health: -10,
                ammo: -5,
              },
            },
            enemies: ["bear"],
            weightAdjustment: 5,
          },
          night: {
            description: "event.river.wildlife.spring.night.description",
            effect: {
              resources: {
                health: -15,
                ammo: -10,
              },
              traits: {
                stealth: -1,
              },
            },
            enemies: ["cougar"],
            weightAdjustment: 10,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.river.wildlife.summer.day.description",
            effect: {
              resources: {
                health: -8,
                food: +5,
              },
            },
            weightAdjustment: 0,
          },
          night: {
            description: "event.river.wildlife.summer.night.description",
            effect: {
              resources: {
                health: -12,
                food: +10,
              },
              traits: {
                resilience: +1,
              },
            },
            weightAdjustment: 5,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.river.wildlife.autumn.day.description",
            effect: {
              resources: {
                health: -15,
                ammo: -10,
              },
              traits: {
                infamy: +1,
              },
            },
            enemies: ["elk"],
            weightAdjustment: -5,
          },
          night: {
            description: "event.river.wildlife.autumn.night.description",
            effect: {
              resources: {
                health: -20,
                food: +15,
              },
            },
            enemies: ["bear"],
            weightAdjustment: 0,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.river.wildlife.winter.day.description",
            effect: {
              resources: {
                health: -10,
                ammo: -10,
                food: +5,
              },
            },
            enemies: ["moose"],
            weightAdjustment: -10,
          },
          night: {
            description: "event.river.wildlife.winter.night.description",
            effect: {
              resources: {
                health: -15,
                ammo: -15,
              },
              traits: {
                luck: -1,
              },
            },
            enemies: ["wolf", "wolf", "wolf"],
            weightAdjustment: -5,
          },
        },
      ],
      buttons: [
        {
          title: "event.river.wildlife.button.hunt",
          message: "event.river.wildlife.button.message.hunt",
          combat: {
            description: "event.river.wildlife.button.hunt.description",
            victory: "event.river.wildlife.button.hunt.victory",
            defeat: "event.river.wildlife.button.hunt.defeat",
            enemies: [],
          },
        },
        {
          title: "event.river.wildlife.button.avoid",
          message: "event.river.wildlife.button.message.avoid",
          effect: {},
        },
      ],
    },
    {
      title: "event.river.torrent.title",
      baseWeight: 35,
      variants: [
        {
          season: "spring",
          day: {
            description: "event.river.torrent.spring.day.description",
            effect: {
              resources: {
                ammo: -5,
                food: -10,
              },
            },
            weightAdjustment: 10,
          },
          night: {
            description: "event.river.torrent.spring.night.description",
            effect: {
              resources: {
                ammo: -7,
                food: -12,
              },
            },
            weightAdjustment: 15,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.river.torrent.summer.day.description",
            effect: {
              resources: {
                ammo: -3,
                food: -8,
              },
            },
            weightAdjustment: 5,
          },
          night: {
            description: "event.river.torrent.summer.night.description",
            effect: {
              resources: {
                ammo: -5,
                food: -10,
              },
            },
            weightAdjustment: 10,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.river.torrent.autumn.day.description",
            effect: {
              resources: {
                ammo: -4,
                food: -9,
              },
            },
            weightAdjustment: 0,
          },
          night: {
            description: "event.river.torrent.autumn.night.description",
            effect: {
              resources: {
                ammo: -6,
                food: -11,
              },
            },
            weightAdjustment: 5,
          },
        },
        {
          season: "winter",
          day: {
            description: "event.river.torrent.winter.day.description",
            effect: {
              resources: {
                ammo: -2,
                food: -7,
              },
            },
            weightAdjustment: -10,
          },
          night: {
            description: "event.river.torrent.winter.night.description",
            effect: {
              resources: {
                ammo: -4,
                food: -9,
              },
            },
            weightAdjustment: -5,
          },
        },
      ],
      buttons: [
        {
          title: "event.river.torrent.button.cross",
          message: "event.river.torrent.button.message.cross",
          effect: {},
        },
      ],
    },
    {
      title: "event.animalTrapping.title",
      outcome: "positive",
      state: "isIn",
      baseWeight: 20,
      variants: [
        {
          season: "winter",
          day: {
            description: "event.animalTrapping.winter.day.description",
            effect: { resources: { food: +5, coins: +10 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.animalTrapping.winter.night.description",
            effect: { resources: { food: +5, coins: +15 } },
            weightAdjustment: 10,
          },
        },
        {
          season: "spring",
          day: {
            description: "event.animalTrapping.spring.day.description",
            effect: { resources: { food: +10, coins: +5 } },
            weightAdjustment: 0,
          },
          night: {
            description: "event.animalTrapping.spring.night.description",
            effect: { resources: { food: +10, coins: +10 } },
            weightAdjustment: 5,
          },
        },
        {
          season: "summer",
          day: {
            description: "event.animalTrapping.summer.day.description",
            effect: { resources: { food: +15, coins: +5 } },
            weightAdjustment: -5,
          },
          night: {
            description: "event.animalTrapping.summer.night.description",
            effect: { resources: { food: +15, coins: +10 } },
            weightAdjustment: 0,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.animalTrapping.autumn.day.description",
            effect: { resources: { food: +10, coins: +10 } },
            weightAdjustment: -10,
          },
          night: {
            description: "event.animalTrapping.autumn.night.description",
            effect: { resources: { food: +10, coins: +15 } },
            weightAdjustment: -5,
          },
        },
      ],
      buttons: [
        {
          title: "event.animalTrapping.button.collect",
          message: "event.animalTrapping.button.message.collect",
          effect: {},
        },
      ],
    },
    {
      title: "event.coldSnap.title",
      outcome: "negative",
      state: "isIn",
      baseWeight: 30,
      variants: [
        {
          season: "winter",
          day: {
            description: "event.coldSnap.winter.day.description",
            effect: { resources: { food: -10, ammo: -5 } },
            weightAdjustment: 5,
          },
          night: {
            description: "event.coldSnap.winter.night.description",
            effect: { resources: { food: -15, ammo: -10 } },
            weightAdjustment: 10,
          },
        },
        {
          season: "autumn",
          day: {
            description: "event.coldSnap.autumn.day.description",
            effect: { resources: { food: -5, ammo: -2 } },
            weightAdjustment: -5,
          },
          night: {
            description: "event.coldSnap.autumn.night.description",
            effect: { resources: { food: -10, ammo: -5 } },
            weightAdjustment: 0,
          },
        },
      ],
      buttons: [
        {
          title: "event.coldSnap.button.proceed",
          message: "event.coldSnap.button.message.proceed",
          effect: {},
        },
      ],
    },
  ].map((event) => localized(event, localizationData));

export default events;
